import {linkCards} from './_card';
import {filterDropdown} from './_filterDropdown';
import {projectsList} from './_projectsList';

(() => {
  linkCards();
  filterDropdown();
  projectsList();
})();
